/**
 * Shared S3 root for hub mosaic encodes. Local mirrors live under
 * `assets/<folder>/` for re-sync; runtime always loads these absolute URLs.
 */
const HUB_S3_ROOT =
  "https://s3.us-east-1.amazonaws.com/assets.sbnation.com/csk/uploads/verge-features/data-centers/data-centers-hub";

export function hubS3Asset(
  folder: "title" | "loudoun" | "utah" | "arizona" | "ballast",
  path: string,
  version: string,
): string {
  return `${HUB_S3_ROOT}/${folder}/${path.replace(/^\//, "")}?v=${version}`;
}
